import { useQuery } from '@tanstack/react-query'
import { fetchActiveAlerts, fetchAlertsByProduct } from '@/api/stockAlertsApi'

export const useStockAlerts = () => {
  return useQuery({
    queryKey: ['stock-alerts'],
    queryFn: fetchActiveAlerts,
    staleTime: 30 * 1000,
  })
}

export const useStockAlertsByProduct = productId => {
  return useQuery({
    queryKey: ['stock-alerts', productId],
    queryFn: () => fetchAlertsByProduct(productId),
    enabled: !!productId,
    staleTime: 30 * 1000,
  })
}

